import {
    AccountClass,
    AccountSubtype,
    AccountType,
} from "@common/constants/domains/accounting/accounts";

export enum BalanceSheetRowAction {
    CreateAccount = "createAccount",
    MapToExisting = "mapToExisting",
}

export interface AccountProxyObject {
    id: string;
    name: string;
    accountClass: AccountClass | null;
    balance: number | null;
    accountType: AccountType | null;
    accountSubtype: AccountSubtype | null;
    mappedKickAccountId: string | null;
    action: BalanceSheetRowAction | null;
    isActionAccepted: boolean;
}

export enum BalanceSheetImportStep {
    UploadDocument = "uploadDocument",
    EnterBalances = "enterBalances",
    MapAccounts = "mapAccounts",
}
